import ContactsTable from './ContactsTable';

export default ContactsTable;


// WEBPACK FOOTER //
// ./src/components/ContactsTable/index.js